<template>
    <div class="termo-desentranhamento-container">
        <iframe class="cp-iframe" :src="urlAcessoDocumento"></iframe>
    </div>
</template>

<script>
export default {
    name: 'TermoDesentranhamentoRedacao',
    props: {
        urlAcessoDocumento: {
            type: String,
            default: '',
        },
    },
}
</script>

<style scoped>
.termo-desentranhamento-container {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
}

.cp-iframe {
    width: 100%;
    height: 100%;
    border: none;
    flex: 1;
}
</style>